import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';
import {
  getCustomerTemplateOptions,
  preRegisterCustomer,
} from '../../actions/ActionCustomer';
import { tCustomerTemplate } from '../../i18n/customerTemplateImport';
import oClasses from './CustomerIndex.module.scss';

/**
 * Formulario de convite para criar cliente pelo fluxo publico com modelo travado.
 */
const CustomerInviteModal = ({ onClose = () => {}, setAlert = () => {} }) => {
  const [aCustomerTemplates, setCustomerTemplates] = useState([]);
  const [oForm, setForm] = useState({
    cName: '',
    cEmail: '',
    template_id: null,
  });
  const [bIsSubmitting, setIsSubmitting] = useState(false);
  const [bIsConfirmingTemplate, setIsConfirmingTemplate] = useState(false);

  /**
   * Carrega modelos ativos que o admin pode vincular ao convite.
   */
  const loadTemplates = async () => {
    const aTemplates = await getCustomerTemplateOptions().catch(() => []);
    setCustomerTemplates(aTemplates);
  };

  /**
   * Atualiza campos do formulario e invalida a confirmacao quando o modelo for alterado.
   */
  const updateField = evtChange => {
    const { name, value } = evtChange.target;
    setForm({
      ...oForm,
      [name]: name === 'template_id' ? (value ? Number(value) : null) : value,
    });
    if (name === 'template_id') {
      setIsConfirmingTemplate(false);
    }
  };

  /**
   * Envia o convite somente apos o admin confirmar o nome do modelo selecionado.
   */
  const submitInvite = async evtSubmit => {
    evtSubmit.preventDefault();

    if (oForm.template_id && !bIsConfirmingTemplate) {
      setIsConfirmingTemplate(true);
      return;
    }

    try {
      setIsSubmitting(true);
      await preRegisterCustomer(oForm);
      setAlert('success', tCustomerTemplate('customerTemplate.inviteSuccess'));
      onClose();
    } catch (oError) {
      setAlert('error', oError.aMsgErrors || [tCustomerTemplate('customerTemplate.inviteError')]);
    } finally {
      setIsSubmitting(false);
    }
  };

  /**
   * Retorna o formulario ao estado editavel para revisar ou trocar o modelo escolhido.
   */
  const reviewTemplateSelection = () => {
    setIsConfirmingTemplate(false);
  };

  useEffect(() => {
    loadTemplates();
  }, []);

  const oSelectedTemplate = aCustomerTemplates.find(oTemplate => oTemplate.value === oForm.template_id);
  const bLockFieldsForConfirmation = bIsSubmitting || bIsConfirmingTemplate;

  return (
    <form className={oClasses.customerInviteForm} onSubmit={submitInvite}>
      <fieldset>
        <label className="split2">
          {tCustomerTemplate('customerTemplate.inviteName')}
          <Input
            type="text"
            name="cName"
            value={oForm.cName}
            onChange={updateField}
            disabled={bLockFieldsForConfirmation}
          />
        </label>

        <label className="split2">
          {tCustomerTemplate('customerTemplate.inviteEmail')}
          <Input
            required
            type="email"
            name="cEmail"
            value={oForm.cEmail}
            onChange={updateField}
            disabled={bLockFieldsForConfirmation}
          />
        </label>

        <label className={oClasses.customerInviteModelField}>
          {tCustomerTemplate('customerTemplate.baseModel')}
          <Input
            type="select"
            name="template_id"
            value={oForm.template_id || ''}
            onChange={updateField}
            disabled={bLockFieldsForConfirmation}
          >
            <option value="">{tCustomerTemplate('customerTemplate.noModel')}</option>
            {aCustomerTemplates.map(oTemplate => (
              <option key={oTemplate.value} value={oTemplate.value}>{oTemplate.label}</option>
            ))}
          </Input>
        </label>
      </fieldset>

      {bIsConfirmingTemplate && oSelectedTemplate && (
        <section className={oClasses.customerInviteTemplateConfirmation}>
          <span>{tCustomerTemplate('customerTemplate.confirmTemplateLabel')}</span>
          <strong>{oSelectedTemplate.label}</strong>
        </section>
      )}

      <div className="button-stack">
        <button
          type="button"
          className="btn alternate back btn btn-outline-secondary"
          onClick={bIsConfirmingTemplate ? reviewTemplateSelection : onClose}
          disabled={bIsSubmitting}
        >
          {bIsConfirmingTemplate
            ? tCustomerTemplate('customerTemplate.reviewTemplate')
            : tCustomerTemplate('customerTemplate.cancel')}
        </button>
        <button type="submit" className="btn btn btn-secondary" disabled={bIsSubmitting}>
          {bIsSubmitting
            ? tCustomerTemplate('customerTemplate.inviteSubmitting')
            : bIsConfirmingTemplate
              ? tCustomerTemplate('customerTemplate.confirmInviteSubmit')
              : tCustomerTemplate('customerTemplate.inviteSubmit')}
        </button>
      </div>
    </form>
  );
};

CustomerInviteModal.propTypes = {
  onClose: PropTypes.func,
  setAlert: PropTypes.func,
};

export default CustomerInviteModal;
